import API from "../../../../../global/api";


export const requestAddTeamMember = () => {
    return {
        type: "REQUEST_ADD_TEAM_MEMBER",
    };
};
export const successAddTeamMember = (data) => {
    return {
        type: "SUCCESS_ADD_TEAM_MEMBER",
        payload: data,
    };
};
export const errorAddTeamMember = () => {
    return {
        type: "ERROR_ADD_TEAM_MEMBER",
    };
};
export const AddTeamMemberApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddTeamMember());
        API.post(`/teamMember`, data).then((res) => {
            dispatch(successAddTeamMember(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddTeamMember());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetTeamMember = () => {
    return {
        type: "REQUEST_GET_TEAM_MEMBER",
    };
};
export const successGetTeamMember = (data) => {
    return {
        type: "SUCCESS_GET_TEAM_MEMBER",
        payload: data,
    };
};
export const errorGetTeamMember = () => {
    return {
        type: "ERROR_GET_TEAM_MEMBER",
    };
};
export const GetTeamMemberApi = () => {
    return (dispatch) => {
        dispatch(requestGetTeamMember());
        API.get(`/teamMember`).then((res) => {
            let getData = res.data;
            dispatch(successGetTeamMember(getData));
        }).catch((error) => {
            dispatch(errorGetTeamMember());
        })
    };
};


export const requestDeleteTeamMember = () => {
    return {
        type: "REQUEST_DELETE_TEAM_MEMBER",
    };
};
export const successDeleteTeamMember = (user_id) => {
    return {
        type: "SUCCESS_DELETE_TEAM_MEMBER",
        user_id: user_id,
    };
};
export const errorDeleteTeamMember = () => {
    return {
        type: "ERROR_DELETE_TEAM_MEMBER",
    };
};
export const DeleteTeamMemberApi = (id) => {
    return dispatch => {
        dispatch(requestDeleteTeamMember());
        API.delete(`/teamMember/${id}`).then(res => {
            dispatch(successDeleteTeamMember(id))
        }).catch((error) => {
            dispatch(errorDeleteTeamMember())
        });
    }
};


export const requestUpdateTeamMember = () => {
    return {
        type: "REQUEST_UPDATE_TEAM_MEMBER",
    };
};
export const successUpdateTeamMember = (data) => {
    return {
        type: "SUCCESS_UPDATE_TEAM_MEMBER",
        payload: data,
    };
};
export const errorUpdateTeamMember = () => {
    return {
        type: "ERROR_UPDATE_TEAM_MEMBER",
    };
};
export const UpdateTeamMemberApi = (data, oldData) => {
    return dispatch => {
        dispatch(requestUpdateTeamMember());
        API.put(`/teamMember/${oldData._id}`, {
            name: data.name,
            fatherName: data.fatherName,
            residentID: data.residentID,
            department: data.department,
            qualification: data.qualification,
            employeeType: data.employeeType,
        }, {
        }).then(res => {
            dispatch(successUpdateTeamMember([data]))
        }).catch((error) => {
            dispatch(errorUpdateTeamMember());
        })
    }
};